var _rect, _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTbcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 8,
    fill: "#00ADEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4682 9.45955L41.8232 28.8925C41.8232 28.8925 41.7232 29.3925 41.4742 29.1145C39.6593 27.6871 37.7664 26.3617 35.8042 25.1445C34.1692 24.2085 31.3712 23.1765 31.2282 23.0805C30.6042 22.5388 30.1893 21.7959 30.0552 20.9805C29.659 18.0178 29.5208 15.0262 29.6422 12.0395C29.654 11.2361 29.7434 10.4357 29.9092 9.64955C30.0162 9.34055 30.3672 9.28355 30.4682 9.45955Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5711_3644",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 23,
    width: 24,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 23.9346H42.0004V30.6396H18.8574V23.9346Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5711_3644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3847 30.2278C21.729 29.2662 23.9897 28.1122 26.1437 26.7778C28.3037 25.2378 29.3487 24.5408 29.6227 24.3358C29.8967 24.1308 30.2727 23.8518 32.7557 24.7488C35.4272 25.8631 37.9731 27.2576 40.3507 28.9088C41.0337 29.4488 42.5067 30.6718 41.1877 30.6408C39.8687 30.6098 25.1007 30.6288 19.5127 30.6408C19.1667 30.6408 18.6877 30.4968 19.3847 30.2278Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.265 9.83942C29.285 10.6184 28.944 14.4894 28.897 15.2034C28.85 15.9174 28.821 18.9914 28.861 19.7914C28.899 20.5584 29.242 22.6834 28.746 23.3494C26.2283 25.9641 23.187 28.0179 19.821 29.3764C17.558 30.2624 17.67 29.7764 18.721 27.8764C19.587 26.3214 29.254 9.41442 29.265 9.83942Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbcIcon);
export default __webpack_public_path__ + "static/media/tbcIcon.90c8b4eff5e379aa17a793f6fb6c9a11.svg";
export { ForwardRef as ReactComponent };